export const QUESTION_VIEW_TYPES = {
  MULTISELECT_WITH_SEARCH: 'MULTISELECT_WITH_SEARCH',
  OPTIONS_LIST_WITH_SHOW_MORE: 'OPTIONS_LIST_WITH_SHOW_MORE',
};
